module.exports = __webpack_public_path__ + "static/media/NotoSerifTC-Bold.6763b631.woff2";